export const headingTheme = {
  baseStyle: {
    fontWeight: 500,
  },
  variants: {
    emphasized: {
      fontWeight: 600,
      fontStyle: 'italic',
    },
  },
  sizes: {
    md: {
      fontSize: ['xl', '2xl'],
    },
  },
};
